import styled from 'styled-components';
import { motion } from 'framer-motion';

// Containers
export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  text-align: center;
  background-color: #121212;
  color: #fff;
  width: 100%;
`;

export const ContentWrapper = styled.div`
  max-width: 800px;
  width: 100%;
  padding: 0 1rem;
  
  @media (max-width: 480px) {
    padding: 0 0.5rem;
  }
`;

// Texto e cabeçalhos
export const Title = styled(motion.h1)`
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
  font-weight: 700;
  background: linear-gradient(135deg, #6e8efb, #a777e3);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  
  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
  
  @media (max-width: 480px) {
    font-size: 1.8rem;
    margin-bottom: 1.2rem;
  }
`;

export const Subtitle = styled(motion.p)`
  font-size: 1.2rem;
  max-width: 800px;
  margin-bottom: 2.5rem;
  line-height: 1.6;
  opacity: 0.9;
  
  @media (max-width: 768px) {
    font-size: 1.1rem;
    margin-bottom: 2rem;
  }
  
  @media (max-width: 480px) {
    font-size: 1rem;
    margin-bottom: 1.8rem;
  }
`;

// Cartões e contêineres
export const Card = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
  }
`;

// Botões e links
export const PrimaryButton = styled(motion.button)`
  padding: 12px 24px;
  background: linear-gradient(135deg, #6e8efb, #a777e3);
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  }
  
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

export const SecondaryButton = styled(PrimaryButton)`
  background: transparent;
  border: 2px solid #6e8efb;
  color: #6e8efb;
  
  &:hover {
    background: rgba(110, 142, 251, 0.1);
  }
`;

export const LinkButton = styled.a`
  display: inline-block;
  padding: 12px 24px;
  background-color: #4f65f1;
  color: white;
  border-radius: 6px;
  font-weight: 600;
  text-align: center;
  transition: all 0.2s ease;
  text-decoration: none;
  
  &:hover {
    background-color: #3951e7;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  }
`;

// Formulários
export const Input = styled.input`
  width: 100%;
  padding: 12px 16px;
  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  color: white;
  font-size: 1rem;
  transition: all 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: #6e8efb;
    box-shadow: 0 0 0 1px #6e8efb;
  }
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
`;

// Animações
export const fadeIn = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    transition: { duration: 0.5 }
};

export const slideUp = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.5 }
};

export const slideDown = {
    initial: { opacity: 0, y: -20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.5 }
};

// Utilitários de layout
export const Flex = styled.div<{ direction?: string, align?: string, justify?: string, gap?: string }>`
  display: flex;
  flex-direction: ${props => props.direction || 'row'};
  align-items: ${props => props.align || 'center'};
  justify-content: ${props => props.justify || 'center'};
  gap: ${props => props.gap || '0'};
`;

export const ErrorMessage = styled.p`
  color: #ff5757;
  margin-top: 0.5rem;
  font-size: 0.9rem;
`; 